<template>
  <el-dialog
    :title="$t('questionnaire.问卷')"
    :visible.sync="isShow"
    width="1000px"
    ref="answerDialogs"
    :close-on-click-modal="false"
    :before-close="beforeClose"
    @close="close"
    class="answerDialog"
  >
    <div class="modal-con-col">
      <div class="left-nav">
        <el-scrollbar style="height: calc(100% - 40px)" ref="scrollbarRef">
          <ul id="questionnaire-nav">
            <li
              align="center"
              class="pointer"
              :class="{ cur: actionTabsKey === 'new' }"
              @click="newAnswer"
            >
              + {{ $t("questionnaire.新建问卷") }}
            </li>
            <li
              v-for="(itemTab, index) in editableTabs"
              @click="clickTabsItem(itemTab, index)"
              :class="{
                cur:
                  actionTabsKey === `${itemTab.id}` ||
                  actionTabsKey === `${itemTab.confPaperId}`,
              }"
              :key="index"
              class="questionnaire-nav-item"
            >
              <span
                v-if="itemTab.stateV2 == 0"
                class="unstart unstart-question"
                >{{ $t("questionnaire.未发布") }}</span
              ><span v-if="itemTab.stateV2 == 1" class="publishing">{{
                $t("questionnaire.发布中")
              }}</span>
              <span v-if="itemTab.stateV2 == 2" class="unstart">{{
                $t("questionnaire.已终止")
              }}</span
              ><span class="cut">{{ itemTab.title }}</span>
            </li>
          </ul>
        </el-scrollbar>
      </div>
      <addOrEdit
        @refreshList="refreshList"
        v-if="showNew"
        :edit-paper="editPaperInfo"
        @toPublish="toPublish"
        :edit="isEdit"
        ref="showadd"
      />
      <showInfo
        ref="showInfo"
        v-if="showInfo"
        :answer-id="answerId"
        :paper-id="confPaperId"
        :action="actionTabsKey"
        @deleteTo="deleteTo"
        @editPaper="editPaper"
        @refreshList="refreshList"
        @refresh="onlyRefresh"
      />
    </div>
  </el-dialog>
</template>

<script>
import showInfo from "@/components/toolList/questionnaire/showInfo";
import addOrEdit from "@/components/toolList/questionnaire/addOrEdit";
import { getPaperList } from "@/api/liveRequest/questionnaireApi";
import { mapGetters } from "vuex";
export default {
  components: {
    showInfo,
    addOrEdit,
  },
  provide() {
    return {
      questionThis: this,
    };
  },
  data() {
    return {
      /**试卷id */
      questionId: null,
      //answerDialogs: false,
      editableTabsValue: "1",
      editableTabs: [],
      TabsHistory: [],
      tabIndex: 1,
      tabsIndex: 1,
      type: "",
      actionTabsKey: "new",
      actionTabsObj: null,
      showInfoState: false,
      loadingState: false,
      showNew: true,
      showInfo: false,
      editPaperInfo: {},
      isEdit: false,
      isShow: false,
      confPaperId: "",
      tempKey: "",
      tempConfId: "",
    };
  },
  watch: {
    isShowAnswer: {
      immediate: true,
      handler: function (value) {
        console.log(value, "value");
        if (value) {
          // this.getPaperListFunc();
          this.init();
        }
        this.isShow = value;
      },
    },
  },
  computed: {
    ...mapGetters(["isShowAnswer"]),
    liveToken() {
      return this.$store.getters.liveToken;
    },
    liveId() {
      return this.$store.getters.liveId;
    },
  },
  methods: {
    editPaper(paper) {
      this.showNew = true;
      this.showInfo = false;
      this.tempKey = "";
      this.actionTabsKey = paper.id;
      this.editPaperInfo = paper;
      this.isEdit = true;
    },
    deleteTo() {
      this.newAnswer();
      this.refreshList();
    },
    newAnswer() {
      this.showNew = true;
      this.showInfo = false;
      this.actionTabsKey = "new";
      this.tempKey = "";
      this.editPaperInfo = {};
      this.isEdit = false;
    },
    refreshList() {
      this.getPaperListFunc();
      console.log(this.tempKey, "进入refresh List this.tempKey");
      if (this.tempKey !== "") {
        this.showNew = false;
        this.showInfo = true;
        this.actionTabsKey = this.tempKey;
        this.answerId = this.tempKey;
        this.confPaperId = this.tempConfId;
      } else {
        //this.actionTabsKey = "new";
        this.isEdit = false;
      }
    },
    onlyRefresh() {
      this.getPaperListFunc();
    },
    /**
     * 关闭时有内容询问，无内容关闭
     */
    beforeClose() {
      if (this.showNew && !this.isWrite()) {
        this.confirmClose();
      } else {
        this.close();
      }
    },
    confirmClose() {
      let tips = this.$t("questionnaire.检测到问卷内容有改动");
      if (!this.isEdit) {
        tips = this.$t("questionnaire.当前内容已填写完成");
      }
      this.$confirm(tips, this.$t("questionnaire.提示"), {
        confirmButtonText: this.$t("questionnaire.保存"),
        cancelButtonText: this.$t("questionnaire.不保存"),
        closeOnClickModal: false,
        closeOnPressEscape: false,
        distinguishCancelAndClose: true,
        customClass: "confirm_save",
      })
        .then(() => {
          this.$refs.showadd.submeAnswer();
          this.close();
        })
        .catch((action) => {
          if (action === "cancel") {
            this.close();
          }
        });
    },
    close() {
      this.$store.commit("SET_SHOW_ANSWER", false);
    },
    isWrite() {
      const showadd = this.$refs.showadd;
      const ruleForm = showadd.ruleForm;
      const title = ruleForm.title;
      const thirdPartyPaperUri = ruleForm.thirdPartyPaperUri;
      const paperType = ruleForm.paperType;
      if (this.isEdit) {
        if (
          (title !== "" && title !== this.editPaperInfo.title) ||
          this.answerListCheckEdit() ||
          (thirdPartyPaperUri !== "" &&
            thirdPartyPaperUri !== this.editPaperInfo.thirdPartyPaperUri)
        ) {
          return false;
        }
        return true;
      } else {
        if (
          (title !== "" && this.answerListCheck() && paperType === "0") ||
          (paperType === "1" && title !== "" && thirdPartyPaperUri !== "")
        ) {
          return false;
        }
        return true;
      }
    },
    /**
     * 新建时检查是否都填完
     */
    answerListCheck() {
      const showadd = this.$refs.showadd;
      const answerList = showadd.answerList;
      let flags = [];
      answerList.map((item) => {
        if (item.title !== "") {
          flags.push(true);
        } else {
          flags.push(false);
        }
        item.options.map((element) => {
          if (element.item !== "") {
            flags.push(true);
          } else {
            flags.push(false);
          }
        });
      });
      return flags.includes(false) ? false : true;
    },
    /**
     * 编辑时检查是否改变
     */
    answerListCheckEdit() {
      const showadd = this.$refs.showadd;
      const answerList = showadd.answerList;
      const questions = this.editPaperInfo.questions;
      console.log(answerList, "answerList");
      console.log(questions, "editPaperInfo");
      if (answerList.length !== questions.length) {
        return true;
      }
      let flags = [];
      answerList.map((item) => {
        questions.map((element) => {
          if (
            (item.title !== "" && item.title !== element.title) ||
            item.choose !== element.type ||
            item.scaleType !== element.scaleType ||
            item.options.length !== element.options.length ||
            this.compareOptions(item.options, element.options)
          ) {
            flags.push(true);
          } else {
            flags.push(false);
          }
        });
      });
      return flags.includes(true) ? true : false;
    },
    compareOptions(answerOp, questionOp) {
      let flags = [];
      answerOp.map((answer) => {
        questionOp.map((quesiton) => {
          if (
            (answer.item !== "" && answer.item !== quesiton.item) ||
            answer.completion !== quesiton.completion ||
            answer.required !== quesiton.required ||
            answer.score !== quesiton.score
          ) {
            flags.push(true);
          } else {
            flags.push(false);
          }
        });
      });
      return flags.includes(true) ? true : false;
    },
    /**初始化 */
    init() {
      // this.actionTabsKey = "new";
      // this.showInfoState = false;
      // this.actionTabsObj = null;
      this.newAnswer();
      this.getPaperListFunc();
    },
    /**点击列表访问对应问卷 */
    clickTabsItem(key) {
      console.log(key, "点击id");
      console.log(this.actionTabsKey, "this.actionTabsKey");
      if (this.showNew && !this.isWrite()) {
        this.confirmClick(key);
      } else {
        this.toPaper(key);
      }
    },

    confirmClick(key) {
      let tips = this.$t("questionnaire.检测到问卷内容有改动");
      if (!this.isEdit) {
        tips = this.$t("questionnaire.当前内容已填写完成");
      }
      this.$confirm(tips, this.$t("questionnaire.提示"), {
        confirmButtonText: this.$t("questionnaire.保存"),
        cancelButtonText: this.$t("questionnaire.不保存"),
        closeOnClickModal: false,
        closeOnPressEscape: false,
        distinguishCancelAndClose: true,
        customClass: "confirm_save",
      })
        .then(() => {
          this.tempKey = key.id;
          this.tempConfId = key.confPaperId.toString();
          this.$refs.showadd.submeAnswer();
        })
        .catch((action) => {
          if (action === "cancel") {
            this.toPaper(key);
          }
        });
    },
    toPaper(key) {
      this.showNew = false;
      this.showInfo = true;
      this.actionTabsKey = key.id;
      this.answerId = key.id;
      this.confPaperId = key.confPaperId.toString();
    },
    toPublish(id) {
      this.getPaperListFunc();
      console.log(id, "......................");
      this.showNew = false;
      this.showInfo = true;

      if (id) {
        this.tempKey = id;
        this.actionTabsKey = id;
        this.answerId = id;
        this.confPaperId = id;
      }

      //  console.log(this.actionTabsKey, "this.actionTabsKey");
    },
    /**获取问卷列表 */
    getPaperListFunc() {
      getPaperList(
        {
          webcastId: this.liveId,
          createTypes: '0,1'
        },
        this.$store.getters.liveToken
      )
        .then((res) => {
          //console.log(res, "getPaperList");
          if (res.code === 200) {
            this.editableTabs = res.data;
          }
          this.loadingState = false;
        })
        .catch((err) => {
          console.log(err, "err_getPaperList");
          this.loadingState = false;
        });
    },

    refreshPaper() {
      this.getPaperListFunc();
    },
  },
  created() {},
};
</script>
<style scoped lang="scss">
.modal-con-col {
  display: flex;
}
.left-nav ::v-deep .el-scrollbar__wrap {
  overflow-x: hidden;
}
.right-con ::v-deep .el-scrollbar__wrap {
  overflow-x: hidden;
}
.answerDialog ::v-deep {
  .el-dialog__body {
    padding: 0px;
    height: 520px;
  }
  .el-dialog__header {
    background: $dialog-bg-color;
    color: $grey3-color;
  }
  .el-dialog__title {
    color: $grey3-color;
  }
  .el-dialog__body {
    background: $dialog-bg-color;
  }
  .el-input__inner {
    background-color: $purple6-color;
    border-color: #525366;
    color: #fff;
  }
  .el-form-item__label {
    padding-right: 0;
    color: #fff;
    // font-size: 12px;
  }
  .el-input .el-input__count .el-input__count-inner {
    background-color: $purple6-color;
    color: #acb2bf;
  }
  .el-button--mini {
    border-radius: 6px;
  }
  .el-button--primary.is-disabled {
    background: #3986ee;
    border-color: #3986ee;
    opacity: 0.5;
  }
  .el-radio__label {
    font-size: 12px;
  }
}
.left-nav {
  width: 210px;
  color: $white-color;
  font-size: 14px;
  height: 520px;
  li {
    height: 48px;
    line-height: 48px;
  }
  .cur {
    background: $back-answer-color;
  }
}
// .left-nav ::v-deep .el-scrollbar__wrap {
//   overflow-x: hidden;
// }
.right-con ::v-deep .el-scrollbar__wrap {
  overflow-x: hidden;
}
.answerTabs ::v-deep .is-left {
  font-size: 12px;
}
.bottom-link {
  width: 140px;
  position: absolute;
  bottom: 16px;
  background-color: #f1f1f1;
  text-align: center;
  font-size: 12px;
}

// .addAnswerFrom ::v-deep .el-form-item__label {
//   font-size: 12px;
// }
.addAnswerFrom ::v-deep .el-form-item__content {
  line-height: 0px;
}
.addInputLong {
  width: 86%;
  text-align: center;
}
.addInputLongItem {
  width: 74%;
  text-align: center;
  margin-bottom: 6px;
}

.addMoreanswer .input-title-sm {
  width: 80px;
}
.questionnaire-nav-item {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding-left: 8px;
}
.pointer {
  cursor: pointer;
}
.unstart {
  color: $grey3-color;
  height: 20px;
  line-height: 16px;
  border-radius: 293px;
  font-size: 10px;
  padding: 2px 5px;
  margin-right: 5px;
  position: relative;
  box-sizing: border-box;
  background-color: rgba(125, 127, 140, 0.2);
}
.unstart-question {
  color: $bule-color;
  background-color: rgba(57, 134, 238, 0.2);
}
.publishing {
  color: $green3-color;
  height: 20px;
  line-height: 16px;
  border-radius: 293px;
  font-size: 10px;
  padding: 2px 5px;
  margin-right: 5px;
  position: relative;
  box-sizing: border-box;
  background-color: rgba(135, 238, 57, 0.2)
}
.cut {
  display: inline-block;
  width: 58%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
}
::v-deep .el-dialog__header{
  padding: 15px 20px;
}
</style>
<style lang="scss">
::v-deep .el-select-dropdown {
  background: $back-answer-color;
}
.confirm_save {
  background: $purple6-color;
  border: 1px solid $purple6-color;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  width: 360px;
  height: 200px;
  .el-message-box__title {
    text-align: center;
    color: $grey5-color;
    font-size: 14px;
  }
  .el-message-box__message {
    color: #fff;
    text-align: center;
    padding-top: 20px;
    padding-bottom: 20px;
  }

  .el-message-box__btns button:nth-child(2) {
    background-color: $bule-color;
    width: 60px;
    height: 28px;
    line-height: 28px;
    border-radius: 6px;
    padding: 0;
    border: 1px solid $bule-color;
  }
  .el-message-box__btns button:nth-child(1) {
    width: 60px;
    height: 28px;
    background: $quite-color;
    border-radius: 6px;
    padding: 0;
    border: 1px solid $quite-color;
    color: $grey-color;
  }
}
</style>
